// Simple hashtag heading fix - Alternative approach
// This is a standalone function that can be easily integrated

export const fixHashtagHeadings = (content) => {
    if (!content || typeof content !== 'string') {
        return content;
    }
    
    console.log('🔧 SIMPLE HASHTAG FIX: Starting...');
    console.log('📥 Input content:', content.substring(0, 200) + '...');
    
    let result = content;
    
    // STEP 1: Replace hashtag headings (must be at start of line)
    const originalResult = result;
    result = result.replace(/^####\s+(.+)$/gm, '<h4>$1</h4>');
    result = result.replace(/^###\s+(.+)$/gm, '<h3>$1</h3>');
    result = result.replace(/^##\s+(.+)$/gm, '<h2>$1</h2>');
    result = result.replace(/^#\s+(.+)$/gm, '<h1>$1</h1>');
    
    // STEP 2: Replace bold text: **text** -> <strong>text</strong> (AGGRESSIVE MATCHING)
    const beforeBold = result;
    // More aggressive regex that handles multiple patterns
    // eslint-disable-next-line no-useless-escape
    result = result.replace(/\*\*([^\*\n]+?)\*\*/g, '<strong>$1</strong>');
    
    const hasHeadingChanges = result !== originalResult;
    const hasBoldChanges = result !== beforeBold;
    
    console.log('🔍 Found hashtag headings:', hasHeadingChanges);
    console.log('🔍 Found bold text (**text**):', hasBoldChanges);
    
    if (hasBoldChanges) {
        // eslint-disable-next-line no-useless-escape
        console.log('✅ BOLD TEXT CONVERTED:', beforeBold.match(/\*\*[^\*\n]+?\*\*/g));
    }
    
    if (hasHeadingChanges || hasBoldChanges) {
        console.log('📤 Output content:', result.substring(0, 300) + '...');
    }
    
    console.log('✅ SIMPLE HASHTAG FIX: Completed');
    return result;
};

// Test function to verify it works
export const testHashtagFix = () => {
    const testContent = `
# Main Heading
## Sub Heading
### Sub Sub Heading
#### Small Heading
Regular text here with **bold text** and more content.
Another line with **Check** this bold word.
**Required Fields in Your Backend:** should be bold.
Text with **multiple** bold **words** in one line.
`;
    
    console.log('🧪 Testing hashtag fix...');
    console.log('Input:', testContent);
    const result = fixHashtagHeadings(testContent);
    console.log('Output:', result);
    
    // Test specifically for bold text
    // eslint-disable-next-line no-useless-escape
    const boldMatches = testContent.match(/\*\*[^\*\n]+?\*\*/g);
    console.log('🔍 Found bold patterns:', boldMatches);
    
    return result;
};

// Make test function available globally for browser console testing
if (typeof window !== 'undefined') {
    window.testHashtagFix = testHashtagFix;
    window.fixHashtagHeadings = fixHashtagHeadings;
}

export default fixHashtagHeadings;